function nextId() {
    let id = localStorage.getItem('nextId')

    if(id == null) {
        id = 100000000
    } else {
        id = Number(id)
    }

    localStorage.setItem('nextId', id + 1)
    return id
}

export default nextId


// WEBPACK FOOTER //
// ./src/utils/idServer.js